export default __webpack_public_path__ + "static/media/cashIcon.b50ce772.svg";